body {
    font-family: 'Roboto', sans-serif;
    font-weight: 300;
    font-size: 16px;
    line-height: 27px;
    margin: 0 0 10px 0;
}

p {
    text-align: justify;
}

h1, h2, h3, h4, h5, h6 {
    font-family: 'Merriweather', serif;
    font-weight: 400;
    color: #006c66;
}

h1 {
    font-size: 34px;
    line-height: 40px;
    margin: 0 0 12px 0;
}

h2 {
    font-size: 22px;
    line-height: 30px;
    margin: 0 0 8px 0;
}

h3 {
    font-size: 19px;
    line-height: 26px;
    margin: 0 0 8px 0;
}

h4 {
    font-size: 16px;
    line-height: 22px;
    margin: 0 0 8px 0;
}

h5 {
    font-size: 14px;
    line-height: 20px;
    margin: 0 0 8px 0;
}

h6 {
    font-size: 13px;
    line-height: 18px;
    margin: 0 0 8px 0;
}



header{
    background-color: #eeeeee;
}
.navigation {
    background-color: #eeeeee;
    font-family: 'Roboto', sans-serif;
    font-size: 16px;
    font-weight: 400;
    font-variant: normal;
}

.navbar {
    padding: 1rem 0rem 1rem 0rem;
}

a, a:hover{
color: #006c66;
    text-decoration: none;
}

.btn-link{
    color: #006c66;
    text-decoration: none;
}

.dropdown-item.active, .dropdown-item:active{
    background-color: #006c66;
}

.page-item.active .page-link {
    background-color: #006c66;
    border-color: #006c66;
}

.nav-link, .page-link, .page-link:focus, .page-link:hover {
color: #006c66;
}

b, strong{
    color: #555555;
    font-weight: 700;
    font-size: 16px;
    line-height: 25px;
    margin: 0 0 14px 0;
    letter-spacing: 0.2px;
}

em, i {
    font-style: italic;
}


dl {
    padding-left: 20px;
}

.attention{
  color: darkred;
}

aside {
    padding: 20px;
  border: 1px solid;
  border-color:  #eeeeee;
}

dl {
    padding-left: 0;
}
dt {
    padding-top: 1em;
}

.level {
    display: flex;
    align-items: center;
}

.flex {
    flex: 1;
}

.card-header
{
       cursor: pointer;
       padding-top: 26px;
       padding-bottom: 20px;
}



.footer
{
    background-color: #006c66;
    color: white;
    line-height: 60px;
    height: 60px;
    position: absolute;
    bottom: 0;
    width: 100%;
}

#footer a {
    color: white;
}

#footer a:active {
    color: white;
}

#footer a:hover {
    color: white;
}

#page-container{
    position: relative;
    min-height: 100vh;
    padding-bottom: 20px;
}

#content-wrap
{
    padding-bottom: 4em;
}

#footer
{
    position: absolute;
    bottom: 0;
    width: 100%;
    height: 4em;

    padding-top: 1em;
    padding-bottom: 1em;

    background-color: #006c66;
    color: white;

}

.breadcrumb
{
    background-color: white;
    padding: 0;
    margin: 10px 0px 10px 0px;

}

.breadcrumb-item + .breadcrumb-item::before  {
    content: "> ";
}

button {
    margin-bottom: 10px;
}
.navbar-light .navbar-nav .nav-link:focus, .navbar-light .navbar-nav .nav-link:hover {
    color: #006c66 !important;
}

.navbar-nav li {
    padding-left: 0;
}
.navbar-nav li a{color: #333333;}

.dropdown-item {
    font-size: 14px;
    font-weight: 300;
}

.select2-container, .select2-search--inline, .select2-sear__field {
    font-family: 'Roboto', sans-serif;
    font-weight: 300;
    font-size: 16px;
}

.editorial-board-member{
    background-color: #F6F6F6;
    padding: 10px;
    margin-bottom: 15px;
}

.editorial-board-member img{
    float: left;
    padding-right: 10px;
}
